module.exports = __webpack_public_path__ + "media/images/recruitment/landing/bg_phone-4c0e9a81fe5b9ddd20188699e0d0234d.jpg";